module.exports = __webpack_public_path__ + "img/image-user-left.3fc25b21.svg";